const PROJECT_NAME = 'project_guarantee';
const websocket = 'ws://localhost:8080/project_guarantee/websocket/message_';

export function getUrl(type) {
    let protocol = document.location.protocol,//网络协议
        host = document.location.host;//域名+端口号

    let base_url = `${protocol}//${host}/${PROJECT_NAME}`,
        websocket_url = `ws://${host}/${PROJECT_NAME}/websocket/message_`;



    switch (type) {
        case 'base' :
            return base_url;
        case 'websocket' :
            return websocket_url;
            // return websocket;
        default :
            return base_url;
    }
}

export function getUploadFilePath(path) {
    if (path) {
        return path.startsWith('/locate/') ? getUrl() + path : path;
    } else {
        return '';
    }
}
